<template>
  <v-row class="d-flex ma-0 pa-0 justify-space-between" style="width: 100%">
    <v-menu
      ref="menuFrom"
      v-model="menuFrom"
      offset-y
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeFrom"
          :label="$tc('editRegistrations.timeIn')"
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          :rules="rules"
          required
          style="max-width: 235px"
        ></v-text-field>
      </template>
      <v-time-picker
        v-model="timeFrom"
        class="mt-4"
        scrollable
        format="24hr"
        :min="minFrom"
        :max="maxFrom"
        @click="$refs.menuFrom.save(timeFrom)"
      >
        <v-btn
          text
          color="primary"
          @click="menuFrom = false"
          class="v-picker__actions"
        >
          Aceptar
        </v-btn>
      </v-time-picker>
    </v-menu>
    <v-menu
      ref="menuTo"
      v-model="menuTo"
      offset-y
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeTo"
          :label="$tc('editRegistrations.timeOut')"
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          :rules="rules"
          style="max-width: 235px"
        ></v-text-field>
      </template>
      <v-time-picker
        v-model="timeTo"
        class="mt-4"
        format="24hr"
        scrollable
        :min="minTo"
        :max="maxTo"
        @click="$refs.menuTo.save(timeTo)"
      >
        <v-btn
          text
          color="primary"
          @click="menuTo = false"
          class="v-picker__actions"
        >
          Aceptar
        </v-btn>
      </v-time-picker>
    </v-menu>
  </v-row>
</template>

<script>
export default {
  props: {
    minFrom: String,
    maxFrom: String,
    minTo: String,
    maxTo: String,
  },
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
    };
  },
  computed: {
    timeFrom: {
      get() {
        return this.$store.state.gestionTiempos.timeFrom;
      },
      set(newDate) {
        this.setTimeFrom(newDate);
      },
    },
    timeTo: {
      get() {
        return this.$store.state.gestionTiempos.timeTo;
      },
      set(newDate) {
        this.setTimeTo(newDate);
      },
    },
  },
  methods: {
    setTimeFrom(date) {
      this.$store.commit("gestionTiempos/setTimeFrom", date);
    },
    setTimeTo(date) {
      this.$store.commit("gestionTiempos/setTimeTo", date);
    },
  },
};
</script>

<style scoped>
.v-picker__actions {
  min-width: 100% !important;
  display: flex !important;
  justify-content: flex-end !important;
}
</style>
